

import api from '@/utils/api';

const BASE = (companyId) => `/companies/${companyId}/onboarding-state`;


export const getOnboardingState = async (companyId) => {
  const response = await api.get(BASE(companyId));
  return response.data?.data?.onboarding_state ?? {};
};


export const markTourCompleted = async (companyId, tourKey) => {
  const response = await api.patch(BASE(companyId), { tour_key: tourKey });
  return response.data?.data?.onboarding_state ?? {};
};
